<template>
  <form class="new-note">
    <textarea placeholder="Skriv inn notat" name="note-text" class="note-text" v-model="newNoteText"></textarea>
    <PageAddButtons @click="newNote" />
  </form>
</template>

<script>
import { mapActions } from 'vuex'
import PageAddButtons from './PageAddButtons'

export default {
  data () {
    return {
      newNoteText: ''
    }
  },
  methods: {
    newNote (pageNumber) {
      if (!this.newNoteText) {
        return
      }

      this.addNote({ pageNumber: pageNumber, note: this.newNoteText }).then(() => {
        this.newNoteText = ''
        this.$emit('added')
      })
    },
    ...mapActions(['addNote', 'deleteNote'])
  },
  components: {
    PageAddButtons
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/NoteForm.vue